/* eslint-disable */
// Import metadata generated by localazy
import meta from './meta';
import en from './en';

export const languageCodes = meta.languages.map(({ language }) => language)
  // We'll always force-load English, so omit it from the language codes
  .filter((candidate) => candidate !== 'en');

// Export a messages object for english
export const messages = {
  en,
};

// Export a loader for other languages
export const loadLanguage = async lang => (await import(`./${lang}.js`)).default;

export default messages;
